
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import logo1 from "../image/logo_v3.svg";
import bgimage from "../image/bg-image.jpg";
import axiosInstance from "../api/axiosInstance";

const Login = ({ updateUser }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const vendorUrl = `${process.env.REACT_APP_ANOTHER_API_URL}/auth/oracle?role=vendor`;
  const buyerUrl = `${process.env.REACT_APP_ANOTHER_API_URL}/auth/oracle?role=buyer`;

  /** Handles User Login */
  const handleLogin = async (email, displayName) => {
    const payload = { userid: email, password: "" };
    const token = Cookies.get("idcs_user_assertion");
    localStorage.setItem("displayName", displayName);

    try {
      const response = await axiosInstance.post(
        `/api/HFTUserLogin`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            Role: Cookies.get("role"),
          },
        }
      );

      // localStorage.setItem("userData", JSON.stringify(response?.data[0]));


      switch (response?.data[0]?.roleName) {
        case "SUPPLIER_ROLE": {
          const url = sessionStorage.getItem("my_task_url");
          const returnUrl = Cookies.get("returnUrl");
          localStorage.setItem("userDataArray", JSON.stringify(response?.data));
          if (response?.data?.length === 1) {
            localStorage.setItem("userData", JSON.stringify(response?.data[0]))
            updateUser(response?.data[0]);
          }
          if (url) {
            sessionStorage.removeItem("event_url");
            navigate(url);
          } else if (returnUrl) {
            // Cookies.remove("returnUrl");
            navigate(returnUrl);
          } else {
            navigate("/vendor");
          }
         
          
          break;
        }

        case "BUYER_ROLE":
        case "MANAGER_ROLE":
        case "OVERSEAS_ROLE":
          response.data[0]["roleName"] = "BUYER_ROLE";
          localStorage.setItem("userData", JSON.stringify(response.data[0]));
          updateUser(response.data[0]);
          localStorage.setItem("userDataArray", JSON.stringify(response?.data));
          if (response?.data?.length === 1) {
            // localStorage.setItem("userData", JSON.stringify(response?.data[0]))
            updateUser(response?.data[0]);
          }
          navigate("/buyer");
          break;

        case "ADMIN_ROLE":
          localStorage.setItem("userData", JSON.stringify(response.data[0]));
          updateUser(response.data[0]);
          navigate("/admin");
          break;

        default:
          navigate("/login-error");
      }
    } catch (error) {
      navigate("/login-error");
    } finally {
      setIsLoading(false);
    }
  };

  /** Fetch User Information Post-SSO */
  const getUser = async () => {
    const role = Cookies.get("role");

    try {
      const result = await fetch(
        `${process.env.REACT_APP_ANOTHER_API_URL}/idcs?role=${role}`,
        { method: "GET", credentials: "include" }
      );

      const data = await result.json();
      await handleLogin(data?.token?.sub, data?.token?.user_displayname);
    } catch (err) {
      navigate("/login-error");
    }
  };

  /** Runs Once on Component Mount */
  useEffect(() => {
    if (Cookies.get("idcs_user_assertion")) {
      getUser();
    } else {
      setIsLoading(false);
    }
  }, []);

  /** Handle Vendor Login Click */
  const handleVendorLogin = () => {
    const params = new URLSearchParams(window.location.search);
    const returnUrl = params.get("returnUrl");

    if (returnUrl) {
      Cookies.set("returnUrl", returnUrl, { path: "/", secure: false });
    }

    window.location.href = vendorUrl;
  };

  /** Handle Buyer Login Click */
  const handleBuyerLogin = () => {
    window.location.href = buyerUrl;
  };


  /** Show Loading Screen During Authentication */
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-lg font-semibold">Authenticating... Please wait.</p>
      </div>
    );
  }

  /** Default Login Page UI */
  return (
    <div
      className="relative h-screen w-full bg-cover bg-center"
      style={{ backgroundImage: `url(${bgimage})` }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-lg"></div>
      <div className="relative flex items-center justify-center h-full">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
          <div className="text-center mb-6">
            <img
              src={logo1}
              alt="Logo"
              className="object-contain w-[185px] h-[60px] mx-auto"
            />
            <p className="mt-4 text-gray-700">
              Connecting vendors and buyers to track orders, approvals, and
              manage change requests efficiently.
            </p>
          </div>

          <p className="text-center mb-4">Choose the login option:</p>

          <button
            onClick={handleVendorLogin}
            className="block w-full text-center bg-red-600 text-white py-2 rounded-md mb-2"
          >
            Login as Vendor
          </button>



          <button
            onClick={handleBuyerLogin}
            className="block w-full text-center bg-red-600 text-white py-2 rounded-md"
          >
            Login as HFT Employee
          </button>


          <div className="text-center mt-6">
            <span className="text-gray-600">Powered by:</span>
            <img
              src="https://images.harborfreight.com/media/logos/harborfreight-logo.svg"
              alt="Harbor Freight Logo"
              className="w-[130px] h-[20px] mx-auto mt-2"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
